import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getSupportCarList = async (params: object) => {
  return await GET({ url: Api.getSupportCarList, params, showError: false })
}
